// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3T3eb","inputWrap":"CustomTip_inputWrap__1Zou6"};